
import React from 'react';
import { Search, Plus, Users, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface TripSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onCreateTrip: () => void;
  onJoinTrip?: () => void;
}

const TripSearchBar: React.FC<TripSearchBarProps> = ({ 
  searchTerm, 
  setSearchTerm, 
  onCreateTrip,
  onJoinTrip
}) => {
  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
      <div className="relative w-full sm:w-64">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Search trips..."
          className="pl-9 pr-9"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button
            onClick={handleClearSearch}
            className="absolute right-2.5 top-2.5 text-muted-foreground hover:text-foreground"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="flex gap-2">
        <Button 
          onClick={onCreateTrip}
          className="bg-glowingTeal hover:bg-glowingTeal/90 text-white flex-1 sm:flex-none"
          size="default"
        >
          <Plus className="mr-2 h-4 w-4" /> Create New Trip
        </Button>
        
        {onJoinTrip && (
          <Button 
            onClick={onJoinTrip}
            variant="outline"
            className="border-glowingTeal text-glowingTeal hover:bg-glowingTeal/10 flex-1 sm:flex-none"
            size="default"
          >
            <Users className="mr-2 h-4 w-4" /> Join Trip
          </Button>
        )}
      </div>
    </div>
  );
};

export default TripSearchBar;
